import { ofType } from "redux-observable";
import { forkJoin, of } from "rxjs";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { addNotification } from "../../../actions/ui";
import { DEFAULT_NOTIFICATION_CLOSE_TIMEOUT, NotificationTypeEnum } from "../../../actions/ui/types";
import { BULK_DOWNLOAD_REPORTS_FAILURE, BULK_DOWNLOAD_REPORTS_REQUEST } from "../../../actions/types";
import { bulkDownloadReports, downloadReport, setReportSelection } from "../../../actions";
import { reportsCenterErrorCodes } from "../../../config/errorCodeMessages";
export var bulkDownloadReportsEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe(ofType(BULK_DOWNLOAD_REPORTS_REQUEST), switchMap(function(action) {
        var _action_payload_reportIds, _action_payload;
        var downloadReportRequests = (_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : (_action_payload_reportIds = _action_payload.reportIds) === null || _action_payload_reportIds === void 0 ? void 0 : _action_payload_reportIds.map(function(reportId) {
            var _action_payload, _action_payload1, _action_payload2;
            return api.reportsCenterService.downloadReport({
                logisticsPartyId: (_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.logisticsPartyId,
                term: (_action_payload1 = action.payload) === null || _action_payload1 === void 0 ? void 0 : _action_payload1.term,
                reportType: (_action_payload2 = action.payload) === null || _action_payload2 === void 0 ? void 0 : _action_payload2.reportType,
                reportId: reportId
            }).pipe(catchError(function(err) {
                var _err_receivedException, _err_receivedException1;
                var _reportsCenterErrorCodes_err_receivedException_errorCode;
                return of(downloadReport.failure(err), addNotification({
                    type: NotificationTypeEnum.ERROR,
                    action: BULK_DOWNLOAD_REPORTS_FAILURE,
                    body: (err === null || err === void 0 ? void 0 : (_err_receivedException = err.receivedException) === null || _err_receivedException === void 0 ? void 0 : _err_receivedException.errorCode) ? (_reportsCenterErrorCodes_err_receivedException_errorCode = reportsCenterErrorCodes[err === null || err === void 0 ? void 0 : (_err_receivedException1 = err.receivedException) === null || _err_receivedException1 === void 0 ? void 0 : _err_receivedException1.errorCode]) !== null && _reportsCenterErrorCodes_err_receivedException_errorCode !== void 0 ? _reportsCenterErrorCodes_err_receivedException_errorCode : "download_report_notifications.failure" : "download_report_notifications.failure",
                    timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT
                }));
            }));
        });
        return forkJoin(downloadReportRequests).pipe(mergeMap(function(response) {
            if (response) {
                // TODO: Figure out a better way for bulk download
                response.forEach(function(fileDownloadDetails) {
                    if (fileDownloadDetails === null || fileDownloadDetails === void 0 ? void 0 : fileDownloadDetails.downloadUrl) {
                        window.open(fileDownloadDetails === null || fileDownloadDetails === void 0 ? void 0 : fileDownloadDetails.downloadUrl, "_blank");
                    }
                });
            }
            return of(bulkDownloadReports.success(), setReportSelection([]));
        }));
    }));
};
export default bulkDownloadReportsEpic;

//# sourceMappingURL=index.js.map